import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
  notification: {},
  authorlist: {},
  authorupdate: {},
  articledropdown: {},
  sendEmailApi: {},
  suggestReviewer: {},
  withdraw: {}
};

const AuthorArticleSlice = createSlice({
  name: 'authorarticle',
  initialState,
  reducers: {

    setToast(state, action) {
      state.notification = action.payload;
    },

    setAuthorList(state, action) {
      state.authorlist = action.payload
    },
    setAuthorUpdate(state, action) {
      state.authorupdate = action.payload
    },
    setArticleDropdown(state, action) {
      state.articledropdown = action.payload;
    },
    setSendEmail(state, action) {
      state.sendEmailApi = action.payload
    },
    setSuggestReviewer(state, action) {
      state.suggestReviewer = action.payload
    },
    setWithdraw(state, action) {
      state.withdraw = action.payload
    }


  },
});




export const AuthorArticleListAPi = (tokendata, page, limit, search, option,journal_id) => async (dispatch) => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/author/articleManuscrptList?page=${page}&limit=${limit}&search=${search}&type=${option}&journal_uuid=${journal_id}`,
    {
      headers: {
        "authorization": ` Bearer ${tokendata}`
      }
    }
  )
    .then((res) => {
      console.log(res, "jfdd")
      dispatch(setAuthorList(res?.data))
    })
    .catch((err) => {
      console.log(err?.response, "errerrr");

    })
}

export const AuthorUpdateApi = (tokendata, updatePayload, edituuid) => async (dispatch) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/author/update/manuscript/${edituuid}`, updatePayload,
    {
      headers: {
        "Authorization": ` Bearer ${tokendata}`
      }
    }
  )
    .then((res) => {
      console.log(res, "resupdate")
      dispatch(setAuthorUpdate(res?.data))
      dispatch(setToast({
        status: true, message: res?.data?.message
      }))

    })
    .catch((err) => {
      console.log(err?.response, "errorrr")
      dispatch(setToast({
        status: false, message: err?.response?.data?.message
      }))

    })

}
export const ArticleDropdown = () => async (dispatch) => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/articleType`)
    .then((res) => {
      console.log(res, "jodvfj")
      dispatch(setArticleDropdown(res?.data))
    })
    .catch((err) => {
      console.log(err?.response, "errorr");

    })
}

export const sendEmailtoEditorialApi = (payload, tokendata) => async (dispatch) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/ats/author/sendEmailToEditorOffice`, payload,
    {
      headers: {
        "Authorization": ` Bearer ${tokendata}`
      }
    }
  )
    .then((res) => {
      console.log(res, "jhri")
      dispatch(setSendEmail(res?.data))
      dispatch(setToast({
        status: true, message: res?.data?.message
      }))
    })
    .catch((err) => {
      console.log(err?.response)
      dispatch(setToast({
        status: false, message: err?.response?.data?.message
      }))
    })
}

export const suggestReviewersApi = (payload, tokendata) => async (dispatch) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/author/suggestReviewers`, payload,
    {
      headers: {
        "Authorization": ` Bearer ${tokendata}`
      }
    }
  )
    .then((res) => {
      console.log(res, "dsds")
      dispatch(setSuggestReviewer(res?.data))
      dispatch(setToast({
        status: true, message: res?.data?.message
      }))

    })
    .catch((err) => {
      console.log(err?.response)
      dispatch(setToast({
        status: false, message: err?.response?.data?.message
      }))
    })
}

export const ArticleWithdraw = (uuid, tokendata) => async (dispatch) => {

  const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/auther/withdrawManuScriot/${uuid}`, { uuid: uuid },
    {
      headers: {
        "Authorization": ` Bearer ${tokendata}`
      },

    }
  )
    .then((res) => {
      console.log(res)
      dispatch(setWithdraw(res?.data))
      dispatch(setToast({
        status: true, message: res?.data?.message
      }))
    })

    .catch((err) => {
      console.log(err, "er23ghg2rf")
      dispatch(setToast({
        status: false, message: err?.response?.data?.message
      }))
    })




}











export const { setToast, setAuthorList, setAuthorUpdate, setArticleDropdown, setSendEmail, setSuggestReviewer, setWithdraw } = AuthorArticleSlice.actions;
const AuthorArticleReducer = AuthorArticleSlice.reducer;

export default AuthorArticleReducer;
